import React from 'react';
import './destiny-free-sample.scss';
import Radio from "@material-ui/core/Radio";
import RadioGroup from '@material-ui/core/RadioGroup';


const DestinyFreeSample = ({ recipients, label, labelButton, handleAction, selectDestinySample, canAdd }) => {
    return(
        <div className="f-destiny" >
            <div className="f-destiny-content">
                <h3 className="f-destiny-title" >{label}</h3>
                <RadioGroup className="f-destiny-radiogroup" onChange={ value => selectDestinySample(value.target.value) } >
                    {recipients.map( (value, key) =>
                        <div className="f-destiny-template-radio" key={key}  >
                            <Radio className='f-destiny-radio' name={`${key}`} id={`${key}`} key={key}  value={value} />
                            <label className='f-destiny-radio-label' htmlFor={`${key}`} >{value}</label>
                        </div> 
                        
                    )}
                </RadioGroup>
            </div>
            <div className="f-destiny-buttons" >
                <button className="f-destiny-button" disabled={!canAdd} onClick={handleAction} >{labelButton}</button>    
            </div>
        </div>
    )
}

export default DestinyFreeSample;